import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import CheckIcon from "@mui/icons-material/Check";
import SaveIcon from "@mui/icons-material/Save";
import { Box, Button, Fab, LinearProgress, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { green } from "@mui/material/colors";
import React from "react";
export default function ProgressExample() {
    const [loading, setLoading] = React.useState(false);
    const [success, setSuccess] = React.useState(false);
    const timer = React.useRef(undefined);
    React.useEffect(() => {
        return () => {
            clearTimeout(timer.current);
        };
    }, []);
    const handleButtonClick = () => {
        if (!loading) {
            setSuccess(false);
            setLoading(true);
            timer.current = window.setTimeout(() => {
                setSuccess(true);
                setLoading(false);
            }, 2000);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(Typography, Object.assign({ variant: "h6" }, { children: "Circular" })), _jsxs(Box, Object.assign({ sx: {
                    display: "flex",
                    alignItems: "center",
                    "& > * + *": {
                        ml: 2,
                    },
                } }, { children: [_jsx(CircularProgress, {}), _jsx(CircularProgress, { color: "secondary" }), _jsxs(Box, Object.assign({ sx: {
                            m: 1,
                            position: "relative",
                        } }, { children: [_jsx(Fab, Object.assign({ "aria-label": "save", color: "primary", sx: success
                                    ? {
                                        bgcolor: green[500],
                                        "&:hover": {
                                            bgcolor: green[700],
                                        },
                                    }
                                    : {}, onClick: handleButtonClick }, { children: success ? _jsx(CheckIcon, {}) : _jsx(SaveIcon, {}) })), loading && (_jsx(CircularProgress, { size: 68, sx: {
                                    color: green[500],
                                    position: "absolute",
                                    top: -6,
                                    left: -6,
                                    zIndex: 1,
                                } }))] })), _jsxs(Box, Object.assign({ sx: {
                            m: 1,
                            position: "relative",
                        } }, { children: [_jsx(Button, Object.assign({ variant: "contained", color: "primary", sx: success
                                    ? {
                                        bgcolor: green[500],
                                        "&:hover": {
                                            bgcolor: green[700],
                                        },
                                    }
                                    : {}, disabled: loading, onClick: handleButtonClick }, { children: "Accept terms" })), loading && (_jsx(CircularProgress, { size: 24, sx: {
                                    color: green[500],
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    marginTop: "-12px",
                                    marginLeft: "-12px",
                                } }))] }))] })), _jsx(Typography, Object.assign({ variant: "h6" }, { children: "Linear" })), _jsxs(Box, Object.assign({ sx: {
                    width: 1,
                    "& > * + *": {
                        mt: 2,
                    },
                } }, { children: [_jsx(LinearProgress, {}), _jsx(LinearProgress, { color: "secondary" }), _jsx(LinearBuffer, {}), _jsx(LinearWithValueLabel, {})] }))] }));
}
function LinearBuffer() {
    const [progress, setProgress] = React.useState(0);
    const [buffer, setBuffer] = React.useState(10);
    const progressRef = React.useRef(() => { });
    React.useEffect(() => {
        progressRef.current = () => {
            if (progress > 100) {
                setProgress(0);
                setBuffer(10);
            }
            else {
                const diff = Math.random() * 10;
                const diff2 = Math.random() * 10;
                setProgress(progress + diff);
                setBuffer(progress + diff + diff2);
            }
        };
    });
    React.useEffect(() => {
        const timer = setInterval(() => {
            progressRef.current();
        }, 500);
        return () => {
            clearInterval(timer);
        };
    }, []);
    return _jsx(LinearProgress, { variant: "buffer", value: progress, valueBuffer: buffer });
}
function LinearProgressWithLabel(props) {
    return (_jsxs(Box, Object.assign({ sx: {
            display: "flex",
            alignItems: "center",
        } }, { children: [_jsx(Box, Object.assign({ sx: {
                    width: "100%",
                    mr: 1,
                } }, { children: _jsx(LinearProgress, Object.assign({ variant: "determinate" }, props)) })), _jsx(Box, Object.assign({ sx: {
                    minWidth: 35,
                } }, { children: _jsx(Typography, Object.assign({ variant: "body2", color: "textSecondary" }, { children: `${Math.round(props.value)}%` })) }))] })));
}
function LinearWithValueLabel() {
    const [progress, setProgress] = React.useState(10);
    React.useEffect(() => {
        const timer = setInterval(() => {
            setProgress((prevProgress) => (prevProgress >= 100 ? 10 : prevProgress + 10));
        }, 800);
        return () => {
            clearInterval(timer);
        };
    }, []);
    return _jsx(LinearProgressWithLabel, { value: progress });
}
